import React from 'react'
import { SetPaddingProps } from '../../utils/PaddingContext'
import { useIsMobile } from '../../utils/helpers'
import TestimonialsMobile from './TestimonialsMobile'
import TestimonialsDesktop from './TestimonialsDesktop'

const data = [
    {
        name: 'Kirin Holdings company, limited',
        position: '',
        company: '',
        quote:
      'Biomatter has achieved excellent project results and we are incredibly happy with our partnership. Intelligent Architecture™ platform is a big step forward for protein design.',
        picture: 'kirin',
        pictureClasses: 'max-w-[229px] md:h-auto',
    },
]

const Testimonials = ({ setPadding }: SetPaddingProps) => {
    const isMobile = useIsMobile()
    return isMobile ? (
        <TestimonialsMobile data={data} setPadding={setPadding} />
    ) : (
        <TestimonialsDesktop setPadding={setPadding} data={data} />
    )
}

export default Testimonials
